import { Component } from '@angular/core';
import { map } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { CookiesService } from '../../services/local-storage/cookies.service';

@Component({
  selector: 'anon-cookies-popup',
  templateUrl: './cookies-popup.component.html',
  styleUrls: ['./cookies-popup.component.scss']
})
export class CookiesPopupComponent {
  hideCookiesConsent$: Observable<boolean> = of(false);
  cookiesConsentStatus = this.cookiesService.consent_for_cookies$;

  moreDetailsLink: string = 'https://policies.google.com/technologies/cookies';

  constructor(public cookiesService: CookiesService) {
    this.hideCookiesConsent$ = this.cookiesConsentStatus
      .pipe(map(status => status === 'true'));
  }
}
